// Session Timeout
export const SESSION_WARN_TIME = 4 * 60 * 60 * 1000; // 4 hours
export const SESSION_LOGOUT_TIME = 60 * 1000; // 1 minute

// Cookie Expire
export const COOKIE_DEFAULT_EXPIRE_TIME = 7 * 24 * 60 * 60 * 1000; // 7 days
export const COOKIE_DELETE_EXPIRE_TIME = -1 * 24 * 60 * 60 * 1000; // -1 days

// Schedulable Interview
export const INTERVIEW_LAUNCH_TIME = 15 * 60 * 1000; // 15 minutes
export const ONE_SECOND = 1000; // 1 second

export const STAGE_COMPLETION_MESSAGE_TIME = 10 * 1000; // 10 seconds

export const LDB_DETECTION_TIMER = 1000;

export const ANIMATION_OUT_TIME = 500;

export const STAGE_COUNTER_TIME = 60 * 60 * 1000; // 1 hour

export const API_AUTH_TOKEN_DURATION = '10s';
